import { Component, Inject, OnInit } from '@angular/core';
import { userPermissions } from '@src/constants';
import { Store } from '@src/store';
import { adminActions } from '@src/store/reducers/adminReducer';
import { cloneDeep } from 'lodash';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';

@Component({
    selector: 'properties',
    template: require('./properties.component.html'),
    styles: [require('./properties.component.scss')]
})
export class PropertiesComponent implements OnInit {

    public additionalOption: any;
    public tmpAdditionalOption: any;
    public isAdmin: boolean = false;
    public translations;
    constructor(@Inject('authorizationService') private authorizationService: any,
                private store: Store,
                private translatePipe: TranslatePipe,
                private dialogManagerService: DialogManagerService) {
    }

    public ngOnInit() {
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']).then(value => this.translations = value);
        this.authorizationService.isAuthorizedToPerformAction(userPermissions.GrantAndRevokePrivileges)
            .then(value => this.isAdmin = value);
        this.store.dispatch({ type: adminActions.GET_CONFIGURATION })
            .then((data: any) => {
                this.additionalOption = [{ optionsList: data }];
                this.tmpAdditionalOption = cloneDeep(this.additionalOption);
            });
    }

    public save(): void {
        if (this.additionalOption.length > 0 && this.additionalOption[0].optionsList) {
            this.store.dispatch({
                type: adminActions.SAVE_CONFIGURATION,
                payload: { configuration: this.additionalOption[0].optionsList }
            }).then((data: any) => {
                if (data) {
                    this.tmpAdditionalOption = cloneDeep(this.additionalOption);
                    this.dialogManagerService.showSuccessDialog({ title:'' , text: '' });
                }else {
                    this.dialogManagerService.showErrorDialog({
                        title: this.translations['ERROR'],
                        text: this.translations['UNEXPECTED_ERROR']});
                }
            });
        }
    }

    public cancel(): void {
        this.additionalOption = cloneDeep(this.tmpAdditionalOption);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/admin/properties/properties.component.ts